import { Column } from '~components/table-view';
import { multiSelectEditor } from '~components/table-view/columnEditors';

import { ServiceTypeRow } from '~appointments/reducers/serviceTypes';

const columnsFactory = (allServiceTypes: ServiceTypeRow[], assignableServiceTypes: Set<number>) => {
  const columns: Column[] = [
    {
      id: 'category',
      header: 'Category',
      type: 'text',
      isEditable: false,
    },
    {
      id: 'name',
      header: 'SAH Service',
      type: 'text',
      isEditable: false,
    },
    {
      id: 'service_type_ids',
      header: 'Associated Services',
      type: 'multi-lookup',
      style: { width: '450px' },
      options: allServiceTypes.map(({ id, name }) => ({ id, name })),
      renderEditor: multiSelectEditor((row) => {
        const selected = (row?.service_type_ids ?? []) as number[];

        return allServiceTypes
          .map(({ id, name }) => ({ id, name }))
          .filter(({ id }) => selected.includes(id) || assignableServiceTypes.has(id));
      }, true),
    },
  ];

  return columns;
};

export default columnsFactory;
